<template lang="pug">
  container
    header
      page-title Home
</template>

<script>
export default {
  name: 'Home'
}
</script>
